/**
 * Canonical post-login home paths by role.
 */
export function getRoleHomePath(roleId, practiceId) {
  switch (Number(roleId)) {
    case 1:
    case 2:
      return '/dashboard';
    case 3:
      return practiceId ? `/practices/${practiceId}` : '/dashboard';
    case 4:
      return '/provider-dashboard';
    case 5:
      return '/caregiver-dashboard';
    case 6:
      return '/patient-dashboard';
    case 7:
      return '/system-caregiver-dashboard';
    default:
      return '/dashboard';
  }
}

/**
 * Resolve where to send the user after login/OTP.
 * Prefer a safe role home over legacy/broken server redirect URLs.
 */
export function getPostLoginPath(user, redirectUrl) {
  const roleId = Number(user?.role_id);
  const practiceId = user?.practice_id ?? user?.practiceId;
  const home = getRoleHomePath(roleId, practiceId);
  const url = typeof redirectUrl === 'string' ? redirectUrl.trim() : '';

  if (!url || !url.startsWith('/')) {
    return home;
  }

  // Legacy patient redirect — always send to the patient dashboard (Layout + sidebar).
  if (url === '/patient-details' || url.startsWith('/patient-details/')) {
    return home;
  }

  if (roleId === 6) {
    const allowed =
      url === '/patient-dashboard' ||
      url.startsWith('/patient-dashboard?') ||
      url === '/patient-settings' ||
      url.startsWith('/patient-settings?') ||
      url === '/chat' ||
      url.startsWith('/chat/');
    return allowed ? url : home;
  }

  if (roleId === 3) {
    const practiceHub = practiceId ? `/practices/${practiceId}` : '';
    if (!url || url === '/practices' || url === practiceHub || url === '/dashboard') {
      return practiceHub || '/dashboard';
    }
  }

  return url;
}
